// extracted by mini-css-extract-plugin
export var avatarStack = "styles-module__avatarStack___aTGsU";
export var header = "styles-module__header___O0_A3";
export var title = "styles-module__title___gM5tB";
export var count = "styles-module__count___Ke7pD";
export var modalWrapper = "styles-module__modalWrapper___bks9J";